var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"header":"Novo app Donamaid disponível","text":"O novo app Donamaid para clientes já está disponível nas lojas de aplicativo do iOS e Android. Clique aqui para baixar ou atualizar o seu app.","imagePath":"/static/dashboard/app.svg","inverted":"","gradient":""},on:{"onClick":_vm.handleRedirect}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-352210e6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/components/InfoCards/cards/App.vue
// module id = null
// module chunks = 